import {
  ADDING_NEW_ADMIN,
  ADDING_NEW_ADMIN_JOB,
  ADDING_NEW_CYLINDER,
  ADD_NEW_ADMIN,
  ADD_NEW_ADMIN_ERROR,
  ADD_NEW_ADMIN_JOB,
  ADD_NEW_ADMIN_JOB_ERROR,
  ADD_NEW_CYLINDER,
  ALL_DATA_ROLE_WISE,
  API_LOADER,
  ASSOCIATE_DEALER,
  ASSOCIATE_USER,
  CERTIFICATE_DATA_LIST,
  CERTIFICATE_KEY,
  CERTIFICATE_WISE_STATE_LIST,
  CYLINDER_REF_DATA_LIST,
  CYLINDER_REF_MAP,
  DELETE_SELECTED_CYLINDER,
  EDIT_ADMIN_DATA,
  EDIT_ADMIN_MIDDLEWARE,
  EDIT_CYLINDER_FLAG,
  GETTING_ALL_ADMINS,
  GET_100KG_BORROWED_CYLINDER_DATA,
  GET_100KG_CYLINDER_INFO,
  GET_100KG_LENT_CYLINDER_DATA,
  GET_ADD_USER_LIST,
  GET_ALL_ADMINS,
  GET_ALL_ADMINS_ERROR,
  GET_ALL_CONTRACTOR_LIST,
  GET_ASSOCIATED_DISPOSAL_CONTRACTOR,
  GET_ASSOCIATED_RECYCLE_FACTORY,
  GET_ASSOCIATE_DISPOSER,
  GET_ASSOCIATE_PROCESSOR,
  GET_ASSOCIATE_RECYCLER,
  GET_BUILDING_DATA,
  GET_CERTIFICATE,
  GET_CHILD_ASSOCIATE_CONTRACTOR,
  GET_CHILD_ASSOCIATE_DATA,
  GET_CONTRACTOR_DATA,
  GET_CUSTOMER_DATA,
  GET_CYLINDER_INFO,
  GET_DEALER_DATA,
  GET_DEALER_USER_LIST,
  GET_DISPOSAL_CONTRACTOR_DATA,
  GET_DISPOSAL_ENGINEER_DATA,
  GET_FILED_ENGINEER_DATA,
  GET_NEW_100KG_CYLINDER_DATA,
  GET_NEW_BORROWED_100KG_CYLINDER_DATA,
  GET_NEW_BORROWED_CYLINDER_DATA,
  GET_NEW_CYLINDER,
  GET_NEW_OWNED_100KG_CYLINDER_DATA,
  GET_NEW_OWNED_CYLINDER_DATA,
  GET_NON_ASSOCIATE_USERS,
  GET_PARENT_DATA,
  GET_PIN_CODE,
  GET_RATE_CARD_INFO,
  GET_RECYCLE_ENGINEER_DATA,
  GET_RECYCLE_FACTORY_DATA,
  GET_REFRIGERANT_DATA,
  GET_REGION_LIST,
  GET_SERVICES,
  GET_TRANSPORT_CONTRACTOR_DATA,
  GET_USER_100KG,
  GET_USER_20KG,
  GET_USER_BORROWED,
  GET_USER_LENT,
  GET_USER_OWNED,
  MODAL_OPEN_CLASS_LIST,
  NEW_ADMIN_ADDED,
  NEW_ADMIN_JOB_ADDED,
  NEW_CYLINDER_ADDED,
  RESET_ADMIN_JOB,
  SEARCH_CYLINDER_USING_ID,
  SEARCH_GET_CYLINDER_USING_ID,
  SEARCH_MENU_CYLINDER,
  SEARCH_NON_ASSOCIATE_USERS,
  SERVICE_KEY,
  SET_100KG_BORROWED,
  SET_100KG_CYLINDER_INFO,
  SET_100KG_LENT,
  SET_ADD_USER_LIST,
  SET_ALL_ADMINS,
  SET_ALL_ASSOCIATED_DISPOSAL_CONTRACTOR,
  SET_ALL_ASSOCIATED_RECYCLE_FACTORY,
  SET_ALL_BUILDING,
  SET_ALL_CONTRACTOR,
  SET_ALL_CUSTOMER,
  SET_ALL_DEALER,
  SET_ALL_DISPOSAL_CONTRACTOR,
  SET_ALL_DISPOSAL_ENGINEER,
  SET_ALL_FILED_ENGINEER,
  SET_ALL_RECYCLE_ENGINEER,
  SET_ALL_RECYCLE_FACTORY,
  SET_ALL_REFRIGERANT,
  SET_ALL_TRANSPORT_CONTRACTOR,
  SET_ASSOCIATE_DISPOSER_LIST,
  SET_ASSOCIATE_PROCESSOR_LIST,
  SET_ASSOCIATE_RECYCLER_LIST,
  SET_ASSOCIATE_TRANSPORTER_LIST,
  SET_CHILD_ASSOCIATE_CONTRACTOR,
  SET_CYLINDER_INFO,
  SET_CYLINDER_NAME,
  SET_DEALER_USER_LIST,
  SET_EDITED_CYLINDER_TYPE,
  SET_ERROR_RESPONSE,
  SET_FILL_CYLINDER_LIST,
  SET_MODEL_PARENT_DATA,
  SET_NEW_CYLINDER,
  SET_NON_ASSOCIATE_USERS,
  SET_PARENT_DATA,
  SET_PARENT_USER,
  SET_PIN_CODE,
  SET_RATE_CARD_INFO,
  SET_REPORT_PIN_CODE,
  SET_SELECTED_100_KG,
  SET_SELECTED_CERTIFICATE,
  SET_SELECTED_SERVICE,
  SET_SELECTED_USER,
  SET_SERVICES,
  SET_SERVICE_STATE_LIST,
  SET_USER_100KG,
  SET_USER_20KG,
  SET_USER_BORROWED,
  SET_USER_LENT,
  SET_USER_OWNED,
  SET_USER_WISE_ID,
  SET_VERIFY_STATUS,
  SET_VIEW_DETAILS_DATA,
  UPDATE_CATEGORY_DATA,
  UPDATE_CERTIFICATE,
  UPDATE_NON_ASSOCIATE_USERS,
  UPDATE_USER_DATA,
  UPDATE_USER_PROFILE,
  USER_KEY,
  VERIFY_NAME,
  VERIFY_NAME_ERROR,
  SET_UPLOAD_TYPE
} from "./types";

export const setApiLoader = (payload) => ({
  type: API_LOADER,
  payload,
});
export const setBulkUploadType = (payload) => ({
  type: SET_UPLOAD_TYPE,
  payload,
});

export const setSearchCylinder = (payload) => ({
  type: SEARCH_CYLINDER_USING_ID,
  payload,
});
export const associateDealer = (payload) => ({
  type: ASSOCIATE_DEALER,
  payload
});
export const certificateWiseStateList = (payload) => ({
  type: CERTIFICATE_WISE_STATE_LIST,
  payload,
});
export const certificateDataList = (payload) => ({
  type: CERTIFICATE_DATA_LIST,
  payload,
});
export const getCertificate = (payload) => ({
  type: GET_CERTIFICATE,
  payload,
});
export const editCylinderFlag = (payload) => ({
  type: EDIT_CYLINDER_FLAG,
  payload,
});
export const GetSearchCylinder = (payload) => ({
  type: SEARCH_GET_CYLINDER_USING_ID,
  payload,
});
export const GetSearchMenuCylinder = (payload) => ({
  type: SEARCH_MENU_CYLINDER,
  payload,
});
export const certificateKey = (payload) => ({
  type: CERTIFICATE_KEY,
  payload,
});
export const userKey = (payload) => ({
  type: USER_KEY,
  payload,
});
export const cylinderRefDataList = (payload) => ({
  type: CYLINDER_REF_DATA_LIST,
  payload,
});
export const cylinderRefMap = ({ contractorId } = {}) => ({
  type: CYLINDER_REF_MAP,
  contractorId
});

export const addNewCylinder = (payload) => ({
  type: ADD_NEW_CYLINDER,
  payload,
});
export const addingNewCylinder = () => ({
  type: ADDING_NEW_CYLINDER,
});
export const newCylinderAdded = (payload) => ({
  type: NEW_CYLINDER_ADDED,
  payload,
});

export const addNewAdmin = (payload, msg) => ({
  type: ADD_NEW_ADMIN,
  payload,
  msg
});
export const addingNewAdmin = () => ({
  type: ADDING_NEW_ADMIN,
});

export const associateUsers = (payload) => ({
  type: ASSOCIATE_USER,
  payload
});

export const newAdminAdded = (payload) => ({
  type: NEW_ADMIN_ADDED,
  payload,
});
export const addNewAdminError = (err) => ({
  type: ADD_NEW_ADMIN_ERROR,
  err,
});

export const editAdminDataAction = (payload,isModelClose) => ({
  type: EDIT_ADMIN_MIDDLEWARE,
  payload,
  isModelClose
});

export const editAdminAction = (payload) => ({
  type: EDIT_ADMIN_DATA,
  payload,
});

export const getAllAdmins = (payload) => ({
  type: GET_ALL_ADMINS,
  payload,
});
export const gettingAllAdmins = () => ({
  type: GETTING_ALL_ADMINS,
});
export const setAllAdmins = (payload) => ({
  type: SET_ALL_ADMINS,
  payload,
});
export const getAllAdminsError = (err) => ({
  type: GET_ALL_ADMINS_ERROR,
  err,
});

export const addNewAdminJob = (payload) => ({
  type: ADD_NEW_ADMIN_JOB,
  payload,
});
export const addingNewAdminJob = () => ({
  type: ADDING_NEW_ADMIN_JOB,
});
export const newAdminJobAdded = (payload) => ({
  type: NEW_ADMIN_JOB_ADDED,
  payload,
});
export const addNewAdminJobError = (err) => ({
  type: ADD_NEW_ADMIN_JOB_ERROR,
  err,
});

export const getAllDealerData = (payload) => ({
  type: GET_DEALER_DATA,
  payload,
});

export const setAllDealer = (payload) => ({
  type: SET_ALL_DEALER,
  payload,
});

export const getAllBuildingData = (payload) => ({
  type: GET_BUILDING_DATA,
  payload,
});

export const setAllBuilding = (payload) => ({
  type: SET_ALL_BUILDING,
  payload,
});

export const getAllRecycleFactoryData = (payload, dataId) => ({
  type: GET_RECYCLE_FACTORY_DATA,
  payload,
  dataId,
});
export const setAllRecycleFactory = (payload) => ({
  type: SET_ALL_RECYCLE_FACTORY,
  payload,
});

export const getAllDisposalContractorData = (payload, dataId) => ({
  type: GET_DISPOSAL_CONTRACTOR_DATA,
  payload,
  dataId,
});
export const setAllDisposalContractor = (payload) => ({
  type: SET_ALL_DISPOSAL_CONTRACTOR,
  payload,
});

export const getAllTransportContractorData = (payload, dataId, roleId) => ({
  type: GET_TRANSPORT_CONTRACTOR_DATA,
  payload
});

export const setAllTransportContractor = (payload) => ({
  type: SET_ALL_TRANSPORT_CONTRACTOR,
  payload,
});

export const getAllRefrigerantData = (payload, dataId) => ({
  type: GET_REFRIGERANT_DATA,
  payload,
  dataId,
});

export const setAllRefrigerant = (payload) => ({
  type: SET_ALL_REFRIGERANT,
  payload,
});
export const getAllContractorData = (payload, dataId) => ({
  type: GET_CONTRACTOR_DATA,
  payload,
  dataId,
});

export const setAllContractor = (payload) => ({
  type: SET_ALL_CONTRACTOR,
  payload,
});
export const getAllCustomerData = (payload, dataId) => ({
  type: GET_CUSTOMER_DATA,
  payload,

  dataId,
});

export const setAllCustomer = (payload) => ({
  type: SET_ALL_CUSTOMER,
  payload,
});
export const getAllFiledEngineerData = (payload, dataId) => ({
  type: GET_FILED_ENGINEER_DATA,
  payload,
  dataId,
});

export const setAllFiledEngineer = (payload) => ({
  type: SET_ALL_FILED_ENGINEER,
  payload,
});

export const getAllRecycleEngineerData = (payload, dataId) => ({
  type: GET_RECYCLE_ENGINEER_DATA,
  payload,
  dataId,
});

export const setAllRecycleEngineer = (payload) => ({
  type: SET_ALL_RECYCLE_ENGINEER,
  payload,
});
export const getAllDisposalEngineerData = (payload, dataId) => ({
  type: GET_DISPOSAL_ENGINEER_DATA,
  payload,
  dataId,
});

export const setAllDisposalEngineer = (payload) => ({
  type: SET_ALL_DISPOSAL_ENGINEER,
  payload,
});


export const setAllAssociatedRecycleFactory = (payload) => ({
  type: SET_ALL_ASSOCIATED_RECYCLE_FACTORY,
  payload,
});

export const getAllAssociatedRecycleFactory = (payload, dataId, jobTypeName, roleId) => ({
  type: GET_ASSOCIATED_RECYCLE_FACTORY,
  payload,
  dataId,
  jobTypeName,
  roleId
});
export const setAllAssociatedDisposalContractor = (payload) => ({
  type: SET_ALL_ASSOCIATED_DISPOSAL_CONTRACTOR,
  payload,
});

export const getAllAssociatedDisposalContractor = (payload, dataId) => ({
  type: GET_ASSOCIATED_DISPOSAL_CONTRACTOR,
  payload,
  dataId,
});


export const setUserWiseId = (payload) => ({
  type: SET_USER_WISE_ID,
  payload,
});


export const setUserOwned = (payload) => ({
  type: SET_USER_OWNED,
  payload,

});
export const getUserOwned = (payload, dataId, roleId) => ({
  type: GET_USER_OWNED,
  payload,
  dataId,
  roleId,
});

export const setUserBorrowed = (payload) => ({
  type: SET_USER_BORROWED,
  payload,
});
export const getUserBorrowed = (payload, dataId, roleId) => ({
  type: GET_USER_BORROWED,
  payload,
  dataId,
  roleId,
});

export const setUserLent = (payload) => ({
  type: SET_USER_LENT,
  payload,
});
export const getUserLent = (payload, dataId, roleId) => ({
  type: GET_USER_LENT,
  payload,
  dataId,
  roleId,
});

export const setUser100kg = (payload) => ({
  type: SET_USER_100KG,
  payload,
});
export const getUser100kg = (payload, dataId, roleId) => ({
  type: GET_USER_100KG,
  payload,
  dataId,
  roleId,
});

export const setUser20kg = (payload) => ({
  type: SET_USER_20KG,
  payload,
});
export const getUser20kg = (payload, dataId) => ({
  type: GET_USER_20KG,
  payload,
  dataId
});

export const verifyName = (payload) => ({
  type: VERIFY_NAME,
  payload,
});
export const verifyNameError = (payload) => ({
  type: VERIFY_NAME_ERROR,
  payload,
});

export const setNewCylinder = (payload) => ({
  type: SET_NEW_CYLINDER,
  payload,
});


export const getCylinderData = (payload) => ({
  type: GET_NEW_CYLINDER,
  payload,
});


export const getPinCode = (payload) => ({
  type: GET_PIN_CODE,
  payload,
});
export const setPinCode = (payload) => ({
  type: SET_PIN_CODE,
  payload,
});
export const setReportPinCode = (payload) => ({
  type: SET_REPORT_PIN_CODE,
  payload,
});

export const setVerifyStatus = (payload) => ({
  type: SET_VERIFY_STATUS,
  payload,
});

export const allDataRoleWise = (payload) => ({
  type: ALL_DATA_ROLE_WISE,
  payload,
});

export const getNewOwnedCylinderData = (payload) => ({
  type: GET_NEW_OWNED_CYLINDER_DATA,
  payload,
});
export const getNewOwned100kgCylinderData = (payload) => ({
  type: GET_NEW_OWNED_100KG_CYLINDER_DATA,
  payload,
});
export const getNewBorrowed100kgCylinderData = (payload) => ({
  type: GET_NEW_BORROWED_100KG_CYLINDER_DATA,
  payload,
});
export const getNewBorrowedCylinderData = (payload) => ({
  type: GET_NEW_BORROWED_CYLINDER_DATA,
  payload,
});

export const get100KGBorrowedCylinderData = (payload) => ({
  type: GET_100KG_BORROWED_CYLINDER_DATA,
  payload,
});
export const get100KGLentCylinderData = (payload) => ({
  type: GET_100KG_LENT_CYLINDER_DATA,
  payload,
});
export const setNew100KGLentCylinder = (payload) => ({
  type: SET_100KG_LENT,
  payload,
});
export const setNew100KGBorrowedCylinder = (payload) => ({
  type: SET_100KG_BORROWED,
  payload,
});

export const getNew100KGCylinderData = (payload) => ({
  type: GET_NEW_100KG_CYLINDER_DATA,
  payload,
});

export const getCylinderInfo = (payload) => ({
  type: GET_CYLINDER_INFO,
  payload,
});
export const setCylinderInfo = (payload) => ({
  type: SET_CYLINDER_INFO,
  payload,
});
export const get100KgCylinderData = (payload) => ({
  type: GET_100KG_CYLINDER_INFO,
  payload,
});
export const set100KgCylinderData = (payload) => ({
  type: SET_100KG_CYLINDER_INFO,
  payload,
});

export const getContractorList = (payload) => ({
  type: GET_ALL_CONTRACTOR_LIST,
  payload,
});

export const getParentList = (payload) => ({
  type: GET_PARENT_DATA,
  payload,
});

export const setParentList = (payload) => ({
  type: SET_PARENT_DATA,
  payload,
});

export const setModelParentList = (payload) => ({
  type: SET_MODEL_PARENT_DATA,
  payload,
});

export const setSelected100KGCylinder = (payload) => ({
  type: SET_SELECTED_100_KG,
  payload,
});

export const setChildAssociateContractor = (payload) => ({
  type: SET_CHILD_ASSOCIATE_CONTRACTOR,
  payload,
});

export const getChildAssociateContractor = (payload) => ({
  type: GET_CHILD_ASSOCIATE_CONTRACTOR,
  payload,
});

export const getRateCardDetails = (payload) => ({
  type: GET_RATE_CARD_INFO,
  payload,
});

export const setRateCardDetails = (payload) => ({
  type: SET_RATE_CARD_INFO,
  payload,
});

export const getServices = (payload) => ({
  type: GET_SERVICES,
  payload,
});

export const setServiceKey = (payload) => ({
  type: SERVICE_KEY,
  payload,
});

export const setServiceList = (payload) => ({
  type: SET_SERVICES,
  payload,
});

export const serviceWiseStateList = (payload) => ({
  type: SET_SERVICE_STATE_LIST,
  payload,
});

export const setSelectedService = (payload) => ({
  type: SET_SELECTED_SERVICE,
  payload,
});

export const setSelectedCertificate = (payload) => ({
  type: SET_SELECTED_CERTIFICATE,
  payload,
});

export const updateCertificateData = (payload) => ({
  type: UPDATE_CERTIFICATE,
  payload,
});

export const updateUserCategory = (payload) => ({
  type: UPDATE_CATEGORY_DATA,
  payload,
});

export const modalOpenClassList = (payload) => ({
  type: MODAL_OPEN_CLASS_LIST,
  payload,
});

export const updateUserProfile = (payload, displayMsg) => ({
  type: UPDATE_USER_PROFILE,
  payload,
  displayMsg
});

export const updateUserData = (payload, isModelClose) => ({
  type: UPDATE_USER_DATA,
  payload,
  isModelClose
});

export const getChildAssociateData = (payload) => ({
  type: GET_CHILD_ASSOCIATE_DATA,
  payload,
});

export const setAddSelectedUser = (payload) => ({
  type: SET_SELECTED_USER,
  payload,
});

export const getAddUserList = (payload) => ({
  type: GET_ADD_USER_LIST,
  payload,
});

export const setAddUserList = (payload) => ({
  type: SET_ADD_USER_LIST,
  payload,
});

export const setParentUser = (payload) => ({
  type: SET_PARENT_USER,
  payload,
});

export const setEditedCylinderType = (payload) => ({
  type: SET_EDITED_CYLINDER_TYPE,
  payload,
});

export const getNonAssociateUsers = (payload) => ({
  type: GET_NON_ASSOCIATE_USERS,
  payload,
});

export const setNonAssociateUsers = (payload) => ({
  type: SET_NON_ASSOCIATE_USERS,
  payload,
});

export const setSearchNonAssociateUsers = (payload) => ({
  type: SEARCH_NON_ASSOCIATE_USERS,
  payload,
});

export const updateNonAssociateUsers = (payload) => ({
  type: UPDATE_NON_ASSOCIATE_USERS,
  payload,
});

export const getDealerList = (payload) => ({
  type: GET_DEALER_USER_LIST,
  payload,
});

export const setAssociateTransporterList = (payload) => ({
  type: SET_ASSOCIATE_TRANSPORTER_LIST,
  payload,
});

export const setDealerList = (payload) => ({
  type: SET_DEALER_USER_LIST, payload
});

export const getAssociateProcessor = (payload) => ({
  type: GET_ASSOCIATE_PROCESSOR, payload
});

export const setAssociateProcessor = (payload) => ({
  type: SET_ASSOCIATE_PROCESSOR_LIST, payload
});

export const getAssociateRecycler = (payload) => ({
  type: GET_ASSOCIATE_RECYCLER, payload
});

export const setAssociateRecycler = (payload) => ({
  type: SET_ASSOCIATE_RECYCLER_LIST, payload
});

export const getAssociateDisposer = (payload) => ({
  type: GET_ASSOCIATE_DISPOSER, payload
});

export const setAssociateDisposer = (payload) => ({
  type: SET_ASSOCIATE_DISPOSER_LIST, payload
});

export const deleteSelectedCylinder = (payload) => ({
  type: DELETE_SELECTED_CYLINDER, payload
});

export const setUserViewDetails = (payload) => ({
  type: SET_VIEW_DETAILS_DATA,
  payload,
});

export const resetAdminData = (payload) => ({
  type: RESET_ADMIN_JOB,
  payload,
});

export const getRegionList = (payload) => ({
  type: GET_REGION_LIST,
  payload,
});


export const setErrorResponse = (payload) => ({
  type: SET_ERROR_RESPONSE,
  payload,
});

export const setCylinderName = (payload) => ({
  type: SET_CYLINDER_NAME,
  payload,
});

export const setFillCylinderList = (payload, keyName) => ({
  type: SET_FILL_CYLINDER_LIST,
  payload,
  keyName
});

